import * as css from "./styles/userFormStyles.module.scss";

import { Hint, Message } from "@zendeskgarden/react-forms";
import { ReactElement } from "react";
import { Dropdown, Field, Item, Label, Menu, Multiselect, Select } from "@zendeskgarden/react-dropdowns";
import Downshift from "downshift";
import { formatterEnumToTitle } from "../../../../../utils/formatters";
import { Tag } from "@zendeskgarden/react-tags";

export interface IUserFormDropdown {
    label: string,
    required: boolean,
    hint?: string,
    disabled?: boolean,
    selection: any | any[],
    itemKey?: string,
    itemValue?: string,
    options: any[],
    error: string | undefined,
    isMultiselect?: boolean,
    downshiftProps?: Record<string, any>,
    popperModifiers?: Record<string, any>,
    valueFormatter?: (val: string) => string,
    onSelect: (evt: any) => void,
    onBlur: () => void,
}

export default function UserFormDropdown(props: IUserFormDropdown): ReactElement {
    let valueFormatter = formatterEnumToTitle;
    const {
        label,
        required,
        hint,
        disabled,
        selection,
        itemKey = "id",
        itemValue = "name",
        options,
        error,
        isMultiselect,
        downshiftProps,
        popperModifiers,
        valueFormatter: valueFormatterProp,
        onSelect,
        onBlur
    } = props;

    if(valueFormatterProp) {
        valueFormatter = valueFormatterProp;
    }

    const selectProp = isMultiselect ? { selectedItems: selection } : { selectedItem: selection };


    const stateReducer = (state: any, changes: any) => {
        switch (changes.type) {
            case Downshift.stateChangeTypes.keyDownEnter:
            case Downshift.stateChangeTypes.clickItem:
                return {
                    ...changes,
                    highlightedIndex: state.highlightedIndex,
                    isOpen: true,
                    inputValue: '',
                };
            default:
                return changes;
        }
    };

    const computedDownshiftProps = {
        defaultHighlightedIndex: 0,
        stateReducer,
        ...downshiftProps,
    };

    return (
        <Dropdown
            inputValue={""}
            onSelect={onSelect}
            downshiftProps={computedDownshiftProps}
            {...selectProp}
        >
            <Field>
                <Label className={css.userFormLabel}>
                    <span>{label}</span>
                    {
                        required && <span className={css.required}>REQUIRED</span>
                    }
                </Label>
                {
                    isMultiselect
                        ? <Multiselect onBlur={onBlur} disabled={disabled} renderItem={({ value, removeValue }) => (
                            <Tag>
                                <span>{value[itemValue] ?? valueFormatter(value)}</span>
                                <Tag.Close onClick={removeValue} />
                            </Tag>
                        )} />
                        : <Select onBlur={onBlur} validation={error ? "error" : undefined}>{selection}</Select>
                }
                {hint && <Hint className={css.hint}>{hint}</Hint>}
                {
                    error &&
                    <Message validation="error">{error}</Message>
                }
            </Field>
            <Menu popperModifiers={popperModifiers}>
                {options.map(option => (
                    <Item key={option[itemKey] ?? option} value={option} disabled={option.disabled}>{valueFormatter(option[itemValue] ?? valueFormatter(option))}</Item>
                ))}
            </Menu>
        </Dropdown>
    );
}